const required = (name, value) => {
  if (!value) throw new Error(`Missing required environment variable: ${name}`);
  return value;
};

export const WHATSAPP_BASE_URL = required(
  "REACT_APP_WHATSAPP_BASE_URL",
  process.env.REACT_APP_WHATSAPP_BASE_URL
);
export const WHATSAPP_NUMBER = required(
  "REACT_APP_WHATSAPP_NUMBER",
  process.env.REACT_APP_WHATSAPP_NUMBER
);
export const CONTACT_EMAIL = required(
  "REACT_APP_CONTACT_EMAIL",
  process.env.REACT_APP_CONTACT_EMAIL
);
export const CONTACT_PHONE_DISPLAY = required(
  "REACT_APP_CONTACT_PHONE_DISPLAY",
  process.env.REACT_APP_CONTACT_PHONE_DISPLAY
);
export const INSTAGRAM_URL = required(
  "REACT_APP_INSTAGRAM_URL",
  process.env.REACT_APP_INSTAGRAM_URL
);

export const CONTACT_PHONE_HREF = `tel:+${WHATSAPP_NUMBER}`;
export const whatsappHref = (message) =>
  `${WHATSAPP_BASE_URL}/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const OFFICE_ADDRESS = {
  label: "Our Investment Desk",
  line1: "Office 307, Tower A1, Fairfox EON",
  line2: "Sector 140A, Noida Expressway",
  line3: "Noida, Uttar Pradesh",
  full: "Office 307, Tower A1, Fairfox EON, Sector 140A, Noida Expressway, Noida, Uttar Pradesh",
};

export const PROJECT_LOCATION = "Fairfox EON · Sector 140A · Noida Expressway";